import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Login from "./components/Login";
// import Dashboard from "./Dashboards/Dashboard";
import Dashboard from "./components/Dashboard";

import "./App.less"


import "./axios-interceptor";
import axios from "axios";
import NotFound from "./components/NotFound";

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      role: "",
    };

    this.logIn = this.logIn.bind(this);
    this.logOut = this.logOut.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem("access_token") !== null) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
      this.fetchProfile();
    }
  }

  logIn = (user) => {
    console.log("auth context login executed ---");
    console.log(user);
    // store the data in the global state
    this.setState({ access_token: user.rawData }, () => {
      // set axios as the default
      axios.defaults.headers.common["Authorization"] = "Bearer " + user.rawData;

      // then fetch the profile and the information
      this.fetchProfile();

      localStorage.setItem("access_token", user.rawData);
      localStorage.setItem("refresh_token", user.refresh_token);
    });
  };

  logOut = async () => {
    console.log("auth context logout executed ---");

    let deleteRefreshToken = {
      refreshToken: localStorage.getItem("refresh_token"),
      token: localStorage.getItem("access_token"),
    };
    await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/user/auth/signout_from_device`,
      deleteRefreshToken
    );

    window.location = `${process.env.REACT_APP_SELF}`;

    localStorage.clear();
  };

  setAxiosDefaultToken = (token) => {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  };

  fetchProfile() {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/api/user/me`)
      .then((response) => {
        console.log(response);
        this.setState({
          username: response.data.username,
          role: response.data.role,
        });
      }).catch((error) => {
        console.log('hey there')
        // console.log(error)
      });
  }

  render() {
    return (
        <Router>
          <Switch>
          <Route exact path="/">
            <Login logIn={this.logIn} logOut={this.logOut} />
          </Route>

          <Route path="/dashboard">
            <Dashboard username={this.state.username} role={this.state.role} />
          </Route>


          <Route component={NotFound} />
          </Switch>
        </Router>
    );
  }
}
